import React from 'react';
import RefundAction from '../actions/refund-action';
import Price from './price';
import Utils from '../utils/utils';
import {VstButton} from 'vstui';

const PurchaseItem = ({
                        item,
                        transaction: {bulk, currency, number, orderDate},
                        className,
                        hideDownloadCodes,
                        hideRefundButton,
                        hideRight,
                        isRefund
                      }) => {
  const vat = Utils.vat(currency);
  const _nonRefundedCopies = item.codes.filter((obj) => !obj.refunded);
  const _accessString = () => {
    const {duration} = item;
    if(!duration){ return null; }
    if(duration === 'perpetual'){
      return i18n.t('transactions.license.perpetual');
    }else{
      let m = duration.match(/(\d+) day/i);
      return i18n.t('transactions.license.days', {days: m[1]});
    }
  }

  const _expirationDate = () => {
    const {item: duration} = item;
    if(duration === 'perpetual'){ return null; }
    // for some reason, the duration can be null sometimes...
    if(!duration){ return null; }
    let start = new Date(orderDate)
      , md    = duration.match(/\d+/)
      , secondsLeft = parseInt(md[0], 10) * 24 * 60 * 60 * 1000;

    return new Date(start.getTime() + secondsLeft);
  }

  const _requestRefund = () => {
    RefundAction.popRequestForm(number, item.isbn);
  }

  const _showRefundRestrictions = e => {
    e.preventDefault();
    RefundAction.showRefundRestrictions(number);
  }

  const _renderRefundDetails = () => {
    const {itemPrice, codes} = item;
    let partialRefund = null;
    if (_nonRefundedCopies.length > 0 && _nonRefundedCopies.length < codes.length) {
      partialRefund = <span>{i18n.t('refunds.bulk.partially-refunded')}</span>;
    }
    if((_nonRefundedCopies.length === 0) || parseFloat(itemPrice) < 0){
      return i18n.t('refunds.states.refunded');

    }else if(codes.some((obj) => obj.refundable)){
      return (
        <div>
          {partialRefund}
          <VstButton className="cloud" options="btn-36" onClick={_requestRefund}>{i18n.t('transactions.request-refund')}</VstButton>
        </div>
      );
    }else{
      return (
        <div>
          {partialRefund}
          <a href="#" onClick={_showRefundRestrictions}>{i18n.t('refunds.states.unavailable')}</a>
        </div>
      );
    }
  }

  const _renderSubTaxes = (arg) => {
    if (currency === "AUD") { return; }
    let subTaxes = item.taxes;
    if (subTaxes.length) {
      subTaxes = subTaxes.map(subTax => Object.assign({}, subTax, { jurisdictionCode: subTax.jurisdictionCode.slice(2) }));
      let gst = subTaxes.findIndex(subTax => subTax.jurisdictionCode == "GST");
      let hst = subTaxes.findIndex(subTax => subTax.jurisdictionCode == "HST");
      if (hst > -1) {
        gst = gst > -1 ? subTaxes.splice(gst, 1) : {tax: 0, taxRate: 0};
        hst = subTaxes.splice(hst, 1)[0];
        subTaxes.push({tax: gst.tax + hst.tax, taxRate: gst.taxRate + hst.taxRate, jurisdictionCode: "GST/HST"});
      }
      subTaxes = subTaxes.reduce((a,b) => {
        if (parseFloat(b.tax) === 0 && b.jurisdictionCode !== "PST") {
          return a;
        }
        return a.concat(
          <div className="price-wrapper">
            <span>{i18n.t("transactions.portion", { subTax: b.jurisdictionCode, rate: Utils.taxRate(b.taxRate) }) }:</span>
            <strong>
              <Price price={b.tax} currency={currency} skipCurrency={true} />
            </strong>
          </div>
        );
      }, []);
    }

    return subTaxes;
  }

  const _downloadCodes = () => {
    let data = item.codes.sort( (x,y) => y.refundable - x.refundable );
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += ['Title', 'ISBN', 'Code', 'Expiration Date', 'Refundable?', 'Reason Non-refundable'] + "\r\n";
    let {title, isbn, quantity} = item;
    let expirationDate = new Date(orderDate);
    expirationDate.setDate(expirationDate.getDate() + 30);
    expirationDate = (expirationDate.getMonth() + 1) + "/" + expirationDate.getDate() + "/" + expirationDate.getFullYear();
    data.forEach(function(codesObj, index){
      let { code, refundable, refundableReasonText } = codesObj;
      let reason = refundableReasonText || "N/A"
      let dataString = [title, isbn, code, expirationDate, refundable, reason];
       csvContent += dataString + "\r\n";
    });
    csvContent += "\r\n".repeat(5);
    csvContent += ['Title', 'Quantity'] + "\r\n";
    csvContent += [title, quantity] + "\r\n";
    csvContent += ['Total', quantity];
    return encodeURI(csvContent);
  }

  let expDate = _expirationDate()
    , expString;

  if(expDate && expDate.getTime() < (new Date()).getTime()){
    expString = i18n.t('transactions.expired');
  }else{
    expString = i18n.t('transactions.expires-in', {date: Utils.toDateString(expDate)});
  }
  let klass = "clear card";
  if(className){ klass += (" " + className); }
  return (
    <div>
      <div className={klass}>
        <div className="left">
          <img className="cover" src={item.imageUrl} alt="" />
          <div className="details">
            <h3 className="title">{item.title}</h3>
            <span className="author">{item.author}</span>
            <span className="expiration-wrapper">
              <span className="duration">{_accessString()}</span>
              {expDate &&
               <span className="expiration">{expString}</span>}
            </span>
            {
              bulk && !hideDownloadCodes && <span className='download-wrapper'>
                <span className='available'>{i18n.t('refunds.bulk.available-codes')}: {_nonRefundedCopies.length}</span>
                <a className='download' download="bulk_purchase_codes.csv" href={_downloadCodes()}>{i18n.t('refunds.bulk.download')}</a>
              </span>
            }
          </div>
        </div>
        {!hideRight && <div className="right">
          <div className="price-wrapper">
            <span>{i18n.t('transactions.price')}
              {(item.tax > 0) && <span className="small"> {!vat && i18n.t('transactions.excluded')}</span>}:
            </span>
            <strong>
              <Price price={Utils._itemPrice(item, currency)} currency={currency} skipCurrency={true}/>
            </strong>
          </div>

          {bulk && <div className="price-wrapper">
            <span>{i18n.t('transactions.quantity')}:</span>
            <strong> {item.quantity}</strong>
          </div>}

          {isRefund && (_renderSubTaxes() || <div className='price-wrapper'>
            <span>{vat || i18n.t('transactions.tax')}:</span>
            <strong>
              <Price price={item.tax} currency={currency} skipCurrency={true} />
            </strong>
          </div>)}

          {(bulk || isRefund) && <div className="price-wrapper">
              <span>{i18n.t('transactions.total')}{(item.tax > 0) && !isRefund && <span className="small"> {!vat && i18n.t('transactions.excluded')}</span>}:</span>
              <strong>
                <Price price={Utils._itemPrice(item, currency, isRefund) * item.quantity} currency={currency} skipCurrency={true}/>
              </strong>
          </div>}

          { isRefund && vat && <span className="vat-disclosure light">{i18n.t('transactions.vat-disclosure', { vat })}</span>}

          { !hideRefundButton && _renderRefundDetails() }
        </div>}
      </div>
    </div>
  );
};

export default PurchaseItem;



/** WEBPACK FOOTER **
 ** ./src/js/components/purchase-item.jsx
 **/